import React from "react";
import { closeIcon } from "../../Icons/Icons";
import { useViewEmployeePayrollDetails } from "../../queries/payrollQuries";
import {
  PAY_SLIP_COMPONENT_TYPE
} from "../../redux/constants/payrollComponents";
import moment from "moment";
import { toast } from "react-toastify";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
   
const GeneratedEmployeeBankStatement = ({ employee, onClose, selectedMonth,selectedYear}) => {
    const axiosPrivate = useAxiosPrivate();
  const {
    data: response,
    isLoading,
    isError,
  } = useViewEmployeePayrollDetails({ employee_id: employee.employee_id, month: selectedMonth,
    year: selectedYear, });
 if (!employee || !employee.employee_id) {
    return (
      <div className="bg-white p-6 rounded shadow max-w-xl mx-auto mt-10 text-center">
        <p className="text-red-500 text-lg font-medium">
          No employee selected. Please choose an employee to view the payroll.
        </p>
      </div>
    );
  }

  const getMonthStart = () => {
    const now = new Date();
    return `01/${String(now.getMonth() + 1).padStart(2, "0")}/${now.getFullYear()}`;
  };

  const getMonthEnd = () => {
    const now = new Date();
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return `${String(end.getDate()).padStart(2, "0")}/${String(end.getMonth() + 1).padStart(2, "0")}/${end.getFullYear()}`;
  };

  const payrollData = response?.data;
 
  const netSalary = payrollData?.employee_payroll_calculated_data?.find(
    (item) => item.component_name === PAY_SLIP_COMPONENT_TYPE.NET_PAY
  );
console.log("payrollData:", netSalary);
//  const totalEarnings = isPending
//     ? 0
//     : earnings.reduce(
//         (sum, curr) => sum + Number(curr.calculated_value || 0),
//         0
//       );
//   const totalDeductions = isPending
//     ? 0
//     : deductions.reduce(
//         (sum, curr) => sum + Number(curr.calculated_value || 0),
//         0
//       );
  if (isLoading) {
    return (
      <div className="bg-white p-6 rounded shadow max-w-xl mx-auto mt-10 text-center">
        <p className="text-blue-500 text-lg font-medium">Loading payroll data...</p>
      </div>
    );
  }



  if (payrollData?.length) {
    return (
      <div className="bg-white p-6 rounded shadow max-w-xl mx-auto mt-10 relative">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-white text-blue-600 text-sm font-medium px-4 py-2"
        >
          {closeIcon}
        </button>
        <p className="text-red-500 text-lg font-medium text-center">
          No payroll policy assigned to this employee.
        </p>
      </div>
    );
  }
// DOWNLOAD PAYSLIP
  const handleDownloadBankStatement = async () => {
    try {
      const response = await axiosPrivate.get(
        "/payroll/fetchEmployeeBankPayments",
      
        {
          params: { employee_id: employee.employee_id,month: selectedMonth || "",
    year: selectedYear || "", download: 1 },
          responseType: "blob",
        }
      );

      const blob = new Blob([response?.data], {
        type: "text/csv;charset=utf-8",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `employee_bank_report_${Date.now()}.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      if(!response?.status) {
        toast.error("No data available to download"); }
      else{
      toast.success("Downloaded successfully");
      }
    } catch (error) {
      console.error("Download error:", error);
      toast.error("Download failed");
    }
  };


  return (
    <div className="bg-gray-50 min-h-screen p-4 md:p-10">
      <div className="bg-white rounded-md shadow border max-w-4xl mx-auto relative">
        <div className="bg-blue-600 text-white px-6 py-4 rounded-t-md flex justify-between items-center">
          <h2 className="text-lg font-semibold">Employee Bank Statement</h2>
          <button
            onClick={onClose}
            className="bg-white text-blue-600 text-sm font-medium px-4 py-2 rounded border border-blue-600 hover:bg-blue-50"
          >
            {closeIcon}
          </button>
        </div>

        <div className="p-6 text-sm text-gray-800 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
            <p><strong>Name:</strong> {employee?.first_name} {employee?.last_name}</p>
            <p><strong>Employee ID:</strong> {employee?.employee_serial}</p>
            <p><strong>Designation:</strong> {payrollData?.designation_title || "N/A"}</p>
            <p><strong>Location:</strong> {payrollData?.office_location || "N/A"}</p>
            <p><strong>Department:</strong> {payrollData?.department_name || "N/A"}</p>
            <p><strong>Role:</strong> {payrollData?.role_name || "N/A"}</p>
            <p><strong>UAN Number:</strong> {payrollData?.uan || "N/A"}</p>
            <p><strong>PAN Number:</strong> {payrollData?.pan_number || "N/A"}</p>
            <p><strong>Bank A/C:</strong> {payrollData?.account_number || "N/A"}</p>
            <p><strong>IFSC Code:</strong> {payrollData?.ifsc_code || "N/A"}</p>
            <p><strong>Pay Period:</strong> {payrollData?.pay_period || `${getMonthStart()} - ${getMonthEnd()}`}</p>
            <p><strong>Payroll Processed Date:</strong> {moment(payrollData?.processed_date).format("DD MMMM YYYY") || "N/A"}</p>
          </div>

        
            <div className="text-gray-800 space-y-1">
              {/* <p className="text-sm font-medium">
                Total Earnings: ₹ {totalEarnings !== null ? totalEarnings.toFixed(2) : "N/A"}
              </p>
              <p className="text-sm font-medium">
                Total Deductions: ₹ {totalDeductions !== null ? totalDeductions.toFixed(2) : "N/A"}
              </p> */}
              <p className="text-lg font-semibold">
                Net Pay: ₹
                {netSalary?.calculated_value && !isNaN(parseFloat(netSalary.calculated_value))
                  ? parseFloat(netSalary.calculated_value).toFixed(2)
                  : "N/A"}
              </p>
            </div>
          
        </div>
       
          
        
      </div>
        <div className="flex justify-end gap-4 mt-6 px-10">
              <button
                onClick={() => handleDownloadBankStatement()}
                className="bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded hover:bg-blue-700"
              >
                Download Bank Statement 
              </button>
            </div>
    </div>
  );
};

export default GeneratedEmployeeBankStatement;
